var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-tooltip',{attrs:{"target":_vm.target,"title":_vm.title}}),_c('font-awesome-icon',{staticClass:"icon ml-1",attrs:{"id":_vm.target,"icon":"question-circle","size":"sm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }